import { ComponentProps } from "react";

type AssignProps = {} & ComponentProps<"button">;

export function Assign({ onClick }: AssignProps) {
  return (
    <>
      <input type="checkbox" id="confirmModal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <p>میخواهید تسک را به خود assign کنید؟</p>
          <div className="flex w-full justify-between mt-10">
            <label htmlFor="confirmModal" className="btn btn-error px-10">
              خیر
            </label>
            <button className="btn btn-info px-10" onClick={onClick}>
              بله
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
